export const AUTH_TOKEN = 'AUTHTOKEN';



// WEBPACK FOOTER //
// ./src/app/shared/utils/CookiesManager.js